module.exports = __webpack_public_path__ + "static/img/b0c864c7-ae55-49c9-aa10-d471960ddc08.251d7004.png";